module.exports = __webpack_public_path__ + "img/bauducco.a9b3dd84.webp";